<template>
  <div>
    <el-button type="primary" @click="$router.go(-1)">返回上一级</el-button>
    <div class="details">
      <li class="title">基本信息：</li>
      <div class="details_warp">
        <div>
          <el-image
            fit="cover"
            v-if="data.headImage"
            :src="$utils.fileUrl(data.headImage)"
            :preview-src-list="[`${$utils.fileUrl(data.headImage)}`]"
          >
          </el-image>
          <el-image
            fit="cover"
            v-if="!data.headImage && data.sex === '男'"
            :src="$utils.fileUrl('/user/picture/head/head-man.svg')"
            :preview-src-list="[
              `${$utils.fileUrl('/user/picture/head/head-man.svg')}`,
            ]"
          >
          </el-image>
          <el-image
            fit="cover"
            v-if="!data.headImage && data.sex === '女'"
            :src="$utils.fileUrl('/user/picture/head/head-woman.svg')"
            :preview-src-list="[
              `${$utils.fileUrl('/user/picture/head/head-woman.svg')}`,
            ]"
          >
          </el-image>
        </div>

        <ul>
          <li>
            <span><b>用户名称：</b>{{ data.realname }}</span
            ><span><b>性别：</b>{{ data.sex }}</span>
          </li>
          <li>
            <span><b>证件类型：</b>{{ idType(data.idType) }}</span
            ><span><b>证件号码：</b>{{ data.idCard }}</span>
          </li>
          <li>
            <span><b>创建账号：</b>{{ data.username }}</span>
          </li>
          <li>
            <span><b>申请日期：</b>{{ $utils.formatDate(data.applyTime) }}</span
            ><span
              ><b>认证日期：</b>{{ $utils.formatDate(data.auditTime) }}</span
            >
          </li>
        </ul>
      </div>
      <li class="title">用户上传的资料图（缩略图）：</li>
      <div class="details_warp——img">
        <el-image
          fit="cover"
          v-if="data.idCardFront"
          :src="$utils.fileUrl(data.idCardFront)"
          :preview-src-list="[
            `${$utils.fileUrl(data.idCardFront)}`,
            `${$utils.fileUrl(data.idCardBack)}`,
          ]"
        >
        </el-image>
        <el-image
          fit="cover"
          v-if="data.idCardBack"
          :src="$utils.fileUrl(data.idCardBack)"
          :preview-src-list="[
            `${$utils.fileUrl(data.idCardFront)}`,
            `${$utils.fileUrl(data.idCardBack)}`,
          ]"
        >
        </el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      itemData: {},
      editVisible: false,
      loading: false,
      reject_dialog: false,
      auditRemark: "",
      idCard: "",
      userName: "",
    };
  },
  methods: {
    async getData() {
      const params = {
        id: this.$route.params.id,
      };
      this.$loading.start();
      const res = await this.$api.account.getPersonalDetails(params);
      this.$loading.done();
      if (res.code === 10200) {
        this.data = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    idType(type) {
      switch (type) {
        case 1:
          return "身份证";
        case 2:
          return "护照";
        case 3:
          return "其他";
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.details {
  margin-top: 24px;
  padding: 24px;
  background-color: #ffffff;

  .title {
    font-weight: 500;
    margin-bottom: 15px;
    font-size: 1.125rem;
  }

  .details_warp {
    display: flex;
    margin-bottom: 33px;
    align-items: center;

    .el-image {
      width: 150px;
      height: 150px;
      margin-right: 24px;
    }

    ul {
      li {
        display: flex;
        height: 38px;
        align-items: center;

        span {
          color: #666666;
          min-width: 230px;
          margin-right: 24px;
          font-size: 0.875rem;
          b {
            font-size: 1rem;
            color: #333333;
            font-weight: 500;
          }
        }
      }
    }
  }

  .details_warp——img {
    .el-image {
      width: 300px;
      height: 200px;
      &:not(:last-child) {
        margin-right: 15px;
      }
    }
  }
}
</style>